import TiersProvider from "./TiersProvider";
import React from "react";
import ConditionProvider from "./ConditionProvider";
import { providerNames, } from "../../../../../server/db/schema/intProvider";
import IntInput from "../intInput/intInput";
import LabeledSelect from "../labeledSelect/labeledSelect";
import ConstProvider from "./constProvider";
import CountProvider from "./CountProvider";
import SumProvider from "./SumProvider";
import OppositeProvider from "./OppositeProvider";
import LabelWithHelp from "../labelWithHelp/labelWithHelp";
import OrderdImageCountProvider from "./OrderedImageCountProvider";
import PerItemProvider from "./PerItemProvider";
import MultiplyProvider from "./MultiplyProvider";
export default function Provider(props) {
    const { provider } = props;
    const providerType = typeof provider === "number" ?
        props.defaultIsPerItemProvider === true ?
            "per-item"
            : "constant"
        : provider.type;
    const options = [
        {
            value: "constant",
            label: providerNames.get("constant"),
            helpText: React.createElement(React.Fragment, null, "Zwraca zdefiniowan\u0105 warto\u015B\u0107"),
        },
        {
            value: "count-provider",
            label: providerNames.get("count-provider"),
            helpText: (React.createElement(React.Fragment, null,
                "Zwraca ilo\u015B\u0107 sztuk danego formatu",
                React.createElement("br", null),
                "zam\u00F3wion\u0105 przez klienta")),
        },
        {
            value: "sum-provider",
            label: providerNames.get("sum-provider"),
            helpText: (React.createElement(React.Fragment, null,
                "Zwraca sum\u0119 wszystkich element\u00F3w",
                React.createElement("br", null),
                "(sumuje je)")),
        },
        {
            value: "revert-provider",
            label: providerNames.get("revert-provider"),
            helpText: (React.createElement(React.Fragment, null,
                "Zwraca liczb\u0119 przeciwn\u0105 do",
                React.createElement("br", null),
                "podanej poni\u017Cej np. 3 -",
                ">",
                " -3")),
        },
        {
            value: "condition-provider",
            label: providerNames.get("condition-provider"),
            helpText: (React.createElement(React.Fragment, null,
                "Zwraca jedn\u0105 z dw\u00F3ch warto\u015Bci",
                React.createElement("br", null),
                "bazuj\u0105c na por\u00F3wnaniu dw\u00F3ch",
                React.createElement("br", null),
                "parametr\u00F3w.")),
        },
        {
            value: "all-orderd-image-formats-sum-provider",
            label: providerNames.get("all-orderd-image-formats-sum-provider"),
            helpText: (React.createElement(React.Fragment, null,
                "Zwraca sum\u0119 zam\u00F3wionych przez",
                React.createElement("br", null),
                "klienta sztuk danego zdj\u0119cia",
                React.createElement("br", null),
                React.createElement("br", null),
                "Bierze pod uwag\u0119 wszystkie",
                React.createElement("br", null),
                "oferty kt\u00F3re s\u0105 dost\u0119pne",
                React.createElement("br", null),
                "dla tego zdj\u0119cia.",
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("b", null,
                    "Suma nie zawiera",
                    React.createElement("br", null),
                    "aktualnego formatu!"))),
        },
        {
            value: "per-item",
            label: providerNames.get("per-item"),
            helpText: (React.createElement(React.Fragment, null,
                "Zwraca koszt wed\u0142ug schematu:",
                React.createElement("br", null),
                "(warto\u015B\u0107)*(sztuk danej oferty)",
                React.createElement("br", null),
                React.createElement("br", null),
                "Jest to domy\u015Blny spos\u00F3b obliczania",
                React.createElement("br", null),
                "ceny za zakupiony format.")),
        },
        {
            value: "multiply-provider",
            label: providerNames.get("multiply-provider"),
            helpText: (React.createElement(React.Fragment, null,
                "Zwraca wynik pomno\u017Cenia przez siebie",
                React.createElement("br", null),
                "dw\u00F3ch warto\u015Bci.",
                React.createElement("br", null),
                React.createElement("br", null),
                "Jego prostrz\u0105 wersj\u0105 jest ",
                React.createElement("code", null, "Cena za sztuk\u0119"),
                ",",
                React.createElement("br", null),
                "Je\u017Celi chcesz, by tw\u00F3j produkt kosztowa\u0142 x z\u0142,",
                React.createElement("br", null),
                "U\u017Cyj ",
                React.createElement("code", null, "Ceny za sztuk\u0119"),
                ".",
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("b", null,
                    "Je\u017Celi potrzebujesz wi\u0119kszej kontroli u\u017Cyj",
                    React.createElement("br", null),
                    React.createElement("code", null, "Mno\u017Cenia warto\u015Bci")))),
        },
        {
            value: "per-item-tiers-provider",
            label: providerNames.get("per-item-tiers-provider"),
            helpText: (React.createElement(React.Fragment, null,
                "Zwraca cen\u0119 na podstawie ustalonych",
                React.createElement("br", null),
                "schod\u00F3w cenowych.",
                React.createElement("br", null),
                React.createElement("br", null),
                "Schody ustalane s\u0105 jako cena za",
                React.createElement("br", null),
                "sztuk\u0119.")),
        },
    ];
    const providerProps = {
        provider,
        formatNames: props.formatNames,
        onProviderUpdate: props.onProviderUpdate,
        hasHiddenType: props.hasHiddenType,
    };
    const selectedTypeIndex = options.findIndex((option) => option.value === providerType);
    const selectedTypeHelp = options[selectedTypeIndex].helpText;
    if (typeof provider === "number") {
        return (React.createElement(React.Fragment, null,
            React.createElement(IntInput, { defaultValue: provider, label: "Cena za sztuk\u0119", onChange: (newValue) => props.onProviderUpdate(newValue) })));
    }
    return (React.createElement("div", { className: "provider-box" },
        !props.hasHiddenType && (React.createElement(LabeledSelect, { onChange: (newType) => props.onProviderUpdate({ type: newType }), options: options, defaultValueIndex: selectedTypeIndex, disableChangeEventOnFirstRender: true, label: React.createElement("div", { className: "int-provider-type-selector-label" },
                "Typ:",
                React.createElement(LabelWithHelp, { text: "", help: React.createElement(React.Fragment, null,
                        React.createElement("b", null, options[selectedTypeIndex].label),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        selectedTypeHelp) })), placeholder: "Wybierz typ..." })),
        typeof provider === "number" ?
            props.defaultIsPerItemProvider === true ?
                React.createElement(React.Fragment, null,
                    React.createElement(PerItemProvider, Object.assign({}, providerProps)))
                : React.createElement(React.Fragment, null,
                    React.createElement(IntInput, { defaultValue: provider, label: "", onChange: (newValue) => props.onProviderUpdate(newValue) }))
            : provider.type === "constant" ?
                React.createElement(ConstProvider, { provider: provider, onProviderUpdate: props.onProviderUpdate })
                : provider.type === "count-provider" ?
                    React.createElement(CountProvider, Object.assign({}, providerProps))
                    : provider.type === "sum-provider" ?
                        React.createElement(SumProvider, Object.assign({}, providerProps))
                        : provider.type === "revert-provider" ?
                            React.createElement(OppositeProvider, Object.assign({}, providerProps))
                            : provider.type === "condition-provider" ?
                                React.createElement(ConditionProvider, Object.assign({}, providerProps))
                                : provider.type === "all-orderd-image-formats-sum-provider" ?
                                    React.createElement(OrderdImageCountProvider, Object.assign({}, providerProps))
                                    : provider.type === "multiply-provider" ?
                                        React.createElement(MultiplyProvider, Object.assign({}, providerProps))
                                        : provider.type === "per-item" ?
                                            React.createElement(PerItemProvider, Object.assign({}, providerProps))
                                            : provider.type === "per-item-tiers-provider" ?
                                                React.createElement(TiersProvider, Object.assign({}, providerProps))
                                                : React.createElement(React.Fragment, null)));
}
